<script>
import ZabiegiLista from "@/components/zabiegi/ZabiegiLista.vue";
import ZabiegiKategorieLista from "@/components/zabiegi/ZabiegiKategorieLista.vue";

export default {
  name: "Zabiegi",
  components: {ZabiegiKategorieLista, ZabiegiLista},
  data() {
    return {
      active_tab: 0
    }
  }
}
</script>

<template>
<v-container fluid>
  <v-row>
    <v-tabs grow v-model="active_tab" slider-color="primary">
        <v-tab ripple key="0">Zabiegi</v-tab>
        <v-tab ripple key="1">Kategorie zabiegów</v-tab>
        <v-tab-item key="0">
          <ZabiegiLista v-if="active_tab == 0"></ZabiegiLista>
        </v-tab-item>
      <v-tab-item key="1">
        <ZabiegiKategorieLista v-if="active_tab == 1"></ZabiegiKategorieLista>
      </v-tab-item>
    </v-tabs>
  </v-row>
</v-container>
</template>

<style scoped>

</style>